<template>
  <img src="wechat.jpeg" @change="on" style="border-radius: 5px;"/>
  <p class="title">{{ title }}</p>
</template>

<script>
export default {
  props: { title: String },
};
</script>
<style scoped>
img {
  user-select: auto;
  pointer-events: auto;
  -webkit-touch-callout: auto;
  -moz-user-select: auto;
  -webkit-user-select: auto;
  -o-user-select: auto;
  width: 100%;
}
.title {
  text-align: center;
  margin: 0;
  color: #787878;
}
</style>
